/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'
/**
 * Import
 * - Actions
 */
import { setStep04c, setStep04cRenewals, resetQuotes, getRenewalVariation } from '../../../actions'
/**
 * Import
 * - Page component
 */
import Step04d from '../../../components/pages/Quote/Step04d/Step04d'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quote,
        fullQuote: (props.editRenewal) ?
            get(state.quote, 'fullRenewals.response.renewal', {}) : get(state.quote, 'full.response.quote', {}),
    }
}

export default connect(
    mapStateToProps,
    {
        setStep04c: setStep04c,
        setStep04cRenewals: setStep04cRenewals,
        resetQuotes: resetQuotes,
        getRenewalVariation,
    }
)(Step04d)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/Step04d.tsx